<template>
    <div class="columns is-multiline is-mobile is-variable is-5">
        <div class="column is-6-mobile is-3-tablet is-3-desktop" v-for="(teamMember, idx) of teamMembers" :key="`member-${idx}`">
            <ob-team-member :team-member="teamMember" :key="teamMember.name"/>
        </div>
    </div>
</template>

<script>
import ObTeamMember from "./components/team-member.vue";
import ceoPhoto from './assets/1635666372395.jpeg';
import ehsanPhoto from './assets/1670079897285.jpeg';
import daryaniPhoto from './assets/1564040838940.jpeg';
import mehrabPhoto from './assets/1641676205321.jpg';
import khaliliPhoto from './assets/1629194476212.jpeg';
import hasaniPhoto from './assets/1641676205326.jpeg';
import jalalPhoto from './assets/1625412952916.jpeg';
import rasiPhoto from './assets/1626867221445.jpeg';

export default {
    components: {ObTeamMember},
    name: 'ob-team-members',
    computed: {
        teamMembers: function () {
            return [
                {
                    name: this.$t('team:team_members.ehsan_name'),
                    position: this.$t('team:team_members.ehsan_title'),
                    photo: ehsanPhoto,
                    links: {
                        github: 'https://github.com/ehsanmqn',
                        instagram: 'https://instagram.com/ehsanmaiqani',
                        linkedin: 'https://www.linkedin.com/in/ehsanmaiqani/',
                    },
                    description: this.$t('team:team_members.ehsan_desc')
                },
                {
                    name: this.$t('team:team_members.daryani_name'),
                    position: this.$t('team:team_members.daryani_title'),
                    photo: daryaniPhoto,
                    links: {
                        github: 'https://github.com/AlirezaDaryani',
                        linkedin: 'https://www.linkedin.com/in/alireza-daryani-9bb08718b/',
                    },
                    description: this.$t('team:team_members.daryani_desc')
                },
                {
                    name: this.$t('team:team_members.ceo_name'),
                    position: this.$t('team:team_members.ceo_title'),
                    photo: ceoPhoto,
                    links: {
                        linkedin: 'https://www.linkedin.com/in/nima-asadinia-a2615992/'
                    },
                    description: this.$t('team:team_members.ceo_desc')
                },
                {
                    name: this.$t('team:team_members.jalal_name'),
                    position: this.$t('team:team_members.jalal_title'),
                    photo: jalalPhoto,
                    links: {
                        github: 'https://github.com/jalallinux',
                        linkedin: 'https://www.linkedin.com/in/jalallinux/'
                    },
                    description: this.$t('team:team_members.jalal_desc')
                },
                {
                    name: this.$t('team:team_members.sadi_name'),
                    position: this.$t('team:team_members.sadi_title'),
                    photo: hasaniPhoto,
                    links: {
                        linkedin: 'https://www.linkedin.com/in/mohammad-hasani-sadi-8a388b218/'
                    },
                    description: this.$t('team:team_members.sadi_desc'),
                },
                {
                    name: this.$t('team:team_members.mehrab_name'),
                    position: this.$t('team:team_members.mehrab_title'),
                    photo: mehrabPhoto,
                    links: {
                        github: 'https://github.com/Mehrabgh2',
                        linkedin: 'https://www.linkedin.com/in/mohammad-hasani-sadi-8a388b218/',
                    },
                    description:  this.$t('team:team_members.mehrab_desc'),
                },
                {
                    name: this.$t('team:team_members.raci_name'),
                    position: this.$t('team:team_members.raci_title'),
                    photo: rasiPhoto,
                    links: {
                        linkedin: 'https://www.linkedin.com/in/mohammad-rasi-masoudi/'
                    },
                    description: this.$t('team:team_members.raci_desc')
                },
                {
                    name: this.$t('team:team_members.khalili_name'),
                    photo: khaliliPhoto,
                    position: this.$t('team:team_members.khalili_title'),
                    description: this.$t('team:team_members.khalili_desc'),
                    links: {
                        github: 'https://github.com/Mohammad-73',
                        linkedin: 'https://www.linkedin.com/in/mohammad-khalili-265121218/',
                    }
                }
            ];
        }
    }
}
</script>
